import * as React from "react";
import { Flipper, Tooltips } from ".";
import type { FlipData } from ".";

// Benefit Flip Imports
import tissue from "../assets/svg/tissue.svg";
import arrowsUp from "../assets/svg/arrowsUp.svg";
import injuredHand from "../assets/svg/injuredHand.svg";
import userOxygen from "../assets/svg/userOxygen.svg";
import userWinning from "../assets/svg/userWinning.svg";

export const RoleOfManagement: React.FC<{}> = () => {
  const benefits: FlipData[] = [
    {
      imgSrc: arrowsUp,
      smallText: "Up to",
      title: "3x",
      description: (
        <>
          Healthy employees are 3x more productive than unhealthy employees.
          <Tooltips id={20} />
        </>
      ),
    },
    {
      imgSrc: injuredHand,
      smallText: null,
      title: null,
      description: (
        <>
          Reduced likelihood of industrial accidents or injuries.
          <Tooltips id={21} />
        </>
      ),
    },
    {
      imgSrc: userWinning,
      smallText: null,
      title: null,
      description: (
        <>
          Create a positive work environment, resulting in healthier and safer
          employees.
          <Tooltips id={22} />
        </>
      ),
    },
    {
      imgSrc: userOxygen,
      smallText: null,
      title: null,
      description: (
        <>
          Decrease the risk of type 2 diabetes, cardiovascular diseases, breast
          and colon cancer.
          <Tooltips id={23} />
        </>
      ),
    },
    {
      imgSrc: tissue,
      smallText: null,
      title: "25%",
      description: (
        <>
          An average 25% reduction in absence due to sick leave.
          <Tooltips id={4} />
        </>
      ),
    },
  ];

  return (
    <div className="px-4 py-5">
      <h2 className="h1 text-center text-uppercase text-warning mb-4">
        Role of management and gaining their support
      </h2>
      <div className="row">
        <div className="col-md-6">
          <p>
            Getting the support of senior managers is especially important as
            they can commit money and people to the program and help make it a
            success. If managers lead the change by supporting the program goals
            and participating, workers will be more enthusiastic and motivated
            to join in.
          </p>
          <p>
            A great way to gain management support is to provide evidence of how
            investing in workplace health and wellbeing will benefit the
            business.
          </p>
          <p>
            Recent studies and reports indicate several benefits that effective
            workplace health and wellbeing programs can produce for both
            individuals and businesses.
          </p>
          <strong className="d-block text-primary mb-4">
            Click the arrows to see some of the potential benefits of workplace
            health and wellbeing programs.
          </strong>
        </div>
        <div className="col-md-6 d-flex justify-content-center align-items-center">
          <Flipper data={benefits} type="benefits" />
        </div>
      </div>
    </div>
  );
};
